import React from 'react';
import { LifeBuoy, X } from 'lucide-react';
import { toast } from 'sonner';

/**
 * Banner que aparece en la parte superior del panel del administrador cuando
 * el superadmin está accediendo en modo soporte (impersonation).
 *
 * Al pulsar "Salir del modo soporte" restaura el token del superadmin y
 * redirige a /superadmin.
 */
export default function ImpersonationBanner() {
  const raw = typeof window !== 'undefined' ? localStorage.getItem('impersonation') : null;
  if (!raw) return null;
  let info;
  try { info = JSON.parse(raw); } catch { return null; }
  if (!info?.super_token) return null;

  const salir = () => {
    localStorage.setItem('app_token', info.super_token);
    localStorage.removeItem('impersonation');
    toast.success('Volviendo al panel superadmin...');
    window.location.href = '/superadmin';
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="bg-blue-600 text-white text-sm border-b border-blue-700 shadow-sm"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 justify-between">
        <div className="flex items-center gap-2 min-w-0">
          <LifeBuoy className="h-4 w-4 shrink-0" />
          <span className="truncate">
            <b>Modo soporte activo</b> — Estás accediendo como <b>{info.admin_full_name}</b>
            {' '}en <b>{info.empresa_nombre}</b>. Cualquier cambio queda registrado en la auditoría de la empresa.
          </span>
        </div>
        <button
          onClick={salir}
          data-testid="impersonation-salir"
          className="shrink-0 flex items-center gap-1.5 rounded-md bg-white/15 hover:bg-white/25 px-3 py-1.5 font-semibold transition-colors"
        >
          <X className="h-3.5 w-3.5" /> Salir del modo soporte
        </button>
      </div>
    </div>
  );
}
